module.exports = __webpack_public_path__ + "static/media/Portrait-10195.58418291.jpg";